import React, { useState, useEffect } from "react";
import { notifyUser, looksLikePhoneNumber, normalizeGhanaPhone, validateGhanaPhone } from "../../../util/util";
import { extractErrorMessage } from '../../../hooks/extractErrorMessage';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LockIcon } from '../../../assets/UiElements/lock.svg';
import { authApi } from '../../../services/auth.service';

export const EmployeeEmailFP = () => {
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [mounted, setMounted] = useState(false);
    const [loading, setLoading] = useState(false);
    const isButtonDisabled = !emailOrPhone || loading;
    const navigate = useNavigate();

    // Delay rendering of omk-text-field until after mount
    useEffect(() => {
        setMounted(true);
    }, []);

    // Send OTP for password reset
    const sendOtp = async () => {
        if (!emailOrPhone) {
            return notifyUser('error', 'Please enter your Email Address or Phone Number!', 'Validation Error');
        }

        // Variable to hold the value to submit (normalized if phone)
        let valueToSubmit = emailOrPhone.trim();

        // Check if input looks like a phone number
        const isPhoneNumber = looksLikePhoneNumber(emailOrPhone);
        if (isPhoneNumber) {
            // Normalize and validate phone number (handles 05XXXXXXXX → 233XXXXXXXX)
            const normalized = normalizeGhanaPhone(emailOrPhone);
            const validation = validateGhanaPhone(normalized);
            
            if (!validation.isValid) {
                return notifyUser('error', validation.error, 'Validation Error');
            }
            
            // Use normalized phone number for submission
            valueToSubmit = normalized;
        }

        setLoading(true);
        
        try {
            // Call forgot password API directly
            const response = await authApi.forgotPassword({ email_or_phone: valueToSubmit });
            console.log('Forgot password response:', response);
            
            const apiData = response?.data || {};
            
            if (apiData.success) {
                // Show success toast with API message
                notifyUser('success', apiData.message || 'OTP sent successfully!', 'Success');
                
                // Get otp_ref from response for OTP verification
                const otpRef = apiData.data?.otp_ref;
                
                // Navigate to OTP page
                navigate('/forgot-password/one-time-password', { 
                    state: { 
                        email_or_phone: valueToSubmit,
                        otpRef: otpRef
                    } 
                });
            } else {
                notifyUser('error', apiData.message || 'Failed to send OTP', 'Error');
            }
        } catch (error) {
            console.error('Forgot password error:', error);
            notifyUser('error', extractErrorMessage(error, 'Network error. Please try again.'), 'Error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Forgot Password</p>
                <small>Enter your Email Address or Phone Number to receive an OTP for password reset.</small>
                <div className="mt-4 w-75 mx-auto mobile-full-width">
                    <div className="mb-5">
                        {mounted && (
                            <omk-text-field 
                                label="Email Address or Phone Number" 
                                value={emailOrPhone} 
                                type='text' 
                                onInput={e => setEmailOrPhone(e.target.value)} 
                                name='email_or_phone'
                                placeholder="Enter Email Address or Phone Number (e.g. 05XXXXXXXX)" 
                            />
                        )}
                    </div>
                    <p className="text-center omk-text-small text-black-50"> 
                        <LockIcon style={{ marginRight: '5px', width: '16px', height: '16px' }} /> 
                        Your information is confidential and secure
                    </p>
                    <button 
                        className={`btn ${isButtonDisabled ? 'btn-secondary' : 'btn-primary'} mb-4 w-50 mobile-full-width`}
                        onClick={sendOtp}
                        disabled={isButtonDisabled}
                        style={{
                            borderRadius: '50px',
                            padding: isButtonDisabled ? '5px 20px' : '10px 20px',
                            height: 'auto',
                        }}
                    >
                        {loading ? 'Sending...' : 'Continue'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmployeeEmailFP;
